var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"app-tag",class:{
    large: _vm.large,
  },style:({
    backgroundColor: _vm.backgroundColor,
    color: _vm.textColor,
  })},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }